<template>
	<div>
		<div class="flex" style="margin-bottom: 70px;">
			<div class="logo">
				<img src="../../assets/ganzhiyu.png" style="width: 100%;padding-top: 3px;" />
			</div>
			<div style="color: #666;font-size: 13px;">提供技术支持</div>
		</div>
		<div class="btn-box" :class="$route.path == '/signIn'? 'ishow':''">
			<div class="retrun_phone" @click="retrun_home">返回首页</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		methods: {
			retrun_home: function() {
				this.$router.push({
					path: '/phone'
				})
			},
		},

	}
</script>

<style scoped>
	.flex {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 40%;
		margin: 20px auto;
		margin-bottom: 10px;
		flex-wrap: nowrap;
	}

	.ishow {
		display: none;
	}

	.logo {
		width: 40px;
		padding: 0 5px;
		/* background-color: #f4f4f4; */
		border-radius: 3px;
	}

	.retrun_phone {
		/* 	font-size: 20px;
		font-weight: bold;
		color: #1e65ff;
		text-align: center;
		margin-bottom: 30px;
		background-color: #eeeeee; */
		margin: 0 auto;
		line-height: 40px;
		text-align: center;
		background-color: #5e89ff;
		color: #fff;
		border-radius: 5px;
		width: 80%;
		/* margin-bottom: 20px; */
		position: fixed;
		bottom: 10px;
		margin-left: 50%;
		transform: translateX(-50%);

	}

	.btn-box {
		position: fixed;
		margin-left: 50%;
		transform: translateX(-50%);
		width: 100%;
		background-color: #fff;
		bottom: 0;
		height: 50px;
	}

	@media (min-width:31.25rem) {
		.btn-box {
			display: none;
		}
		.retrun_phone {
			display: none;
		}
		.flex {
			display: none;
		}
	}
</style>
